module.exports = __webpack_public_path__ + "img/logo.67f56fcd.png";